import React from "react";

interface Props {
  title?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

export const SectionCard: React.FC<Props> = ({ title, action, className = "", children }) => (
  <div className={`rounded-2xl bg-white border border-slate-100 shadow-sm p-5 ${className}`}>
    {(title || action) && (
      <div className="flex items-center justify-between mb-4">
        {typeof title === "string"
          ? <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
          : title}
        {action}
      </div>
    )}
    {children}
  </div>
);

export default SectionCard;
